import { AbstractControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

/** Convertit une valeur en Number, retourne undefined si vide/null */
export function toNumber(v: any): number | undefined {
  return v != null && v !== '' ? Number(v) : undefined;
}

/** Retourne la valeur ou undefined si falsy */
export function toStringOrUndefined(v: any): string | undefined {
  return v || undefined;
}

/** Garantit un tableau à partir d'une valeur scalaire ou array */
export function toArray<T = any>(v: T | T[] | null | undefined): T[] {
  return Array.isArray(v) ? v : (v ? [v] : []);
}

/** Options de période de cotisation partagées entre prévoyance et mutuelle */
export const COTISATION_PERIODE_OPTIONS = [
  { id: 'MENSUEL', label: 'Mensuel' },
  { id: 'ANNUEL', label: 'Annuel' },
];

/**
 * Configure un validateur conditionnel : quand `trigger` change,
 * applique/retire `Validators.required` sur chaque `dependents`.
 * Applique aussi l'état initial sans attendre un changement.
 */
export function setupConditionalValidator(
  trigger: AbstractControl | null | undefined,
  dependents: (AbstractControl | null | undefined)[],
  condition: (value: any) => boolean,
  destroy$: Subject<void>,
): void {
  if (!trigger) return;
  const apply = (value: any) => {
    const isActive = condition(value);
    dependents.forEach(ctrl => {
      if (!ctrl) return;
      if (isActive) {
        ctrl.setValidators(Validators.required);
      } else {
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    });
  };
  // Init depuis la valeur existante
  apply(trigger.value);
  // Réagir aux changements
  trigger.valueChanges.pipe(takeUntil(destroy$)).subscribe(apply);
}

export function parseAmount(value: any): number {
  const parsed = Number(String(value ?? '').replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : 0;
}
